import OnboardingDialog from '@modules/account/components/onboarding/OnboardingDialog';
import ApiRoutes from '@modules/account/defs/api-routes';
import useAuth from '@modules/auth/hooks/api/useAuth';
import useApi from '@common/hooks/useApi';
import { usePwaContext } from '@common/contexts/PwaContext';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

interface OnboardingWorkflowProps {
  children: React.ReactNode;
}
const OnboardingWorkflow = (props: OnboardingWorkflowProps) => {
  const { children } = props;
  const { user } = useAuth();
  const { isWeb, isMobile } = usePwaContext();
  const fetchApi = useApi();
  const [showOnboardingWorkflow, setShowOnboardingWorkflow] = useState(false);
  const conversionCheckedRef = useRef(false);

  useEffect(() => {
    if (user) {
      setShowOnboardingWorkflow(!user.isOnboardingCompleted);
    }
  }, [user, isWeb, isMobile]);

  // Fire Google Ads onboarding conversion event one-shot per user.
  // Backend endpoint is atomic and idempotent : retourne shouldFire=true seulement la 1ère fois.
  useEffect(() => {
    if (!user || !user.isOnboardingCompleted) {
      return;
    }
    if (user.onboardingConversionFiredAt) {
      return;
    }
    if (conversionCheckedRef.current) {
      return;
    }
    conversionCheckedRef.current = true;

    fetchApi<{ shouldFire: boolean }>(ApiRoutes.MarkOnboardingConversionFired, {
      method: 'POST',
      displayErrors: false,
    }).then((res) => {
      if (res.success && res.data?.shouldFire && typeof window !== 'undefined') {
        const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
        gtag?.('event', 'conversion', {
          send_to: 'AW-17526606854/iO0mCNWo5rMcEIaYq6VB',
        });
      }
    });
  }, [user, fetchApi]);

  return (
    <>
      <Box
        sx={{
          filter: showOnboardingWorkflow ? 'blur(1.5px)' : 'none',
          transition: 'filter 0.5s ease',
          pointerEvents: showOnboardingWorkflow ? 'none' : 'auto',
        }}
      >
        {children}
      </Box>
      <OnboardingDialog open={showOnboardingWorkflow} />
    </>
  );
};

export default OnboardingWorkflow;
